import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from 'containers/App/index';
import store from './store';
import 'bulma/css/bulma.css';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js